export default function EFAirConditioner(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Air-Conditioner_icon">
                    <rect id="矩形备份-27" x="0" y="0" width="30" height="30"></rect>
                    <g id="编组-42" strokeLinecap="round" strokeLinejoin="round" transform="translate(0.810811, 6.486487)" stroke="#FFFFFF">
                        <path
                            d="M4.70978932,13.1734145 L5.0433683,13.7604993 C5.22767866,14.084807 5.11208648,14.5030297 4.78533381,14.6950235 C4.45903623,14.8865547 4.34344406,15.3047776 4.52775441,15.6290851 L4.8608783,16.2161699"
                            id="Stroke-336"
                            strokeWidth="1.07946027"
                        ></path>
                        <path
                            d="M9.62687093,16.2162162 L9.29329193,15.6286688 C9.10943666,15.3048237 9.22457373,14.8861384 9.55132636,14.6946072 C9.87807907,14.503076 9.99367125,14.0848533 9.80936093,13.7605456 L9.47578193,13.1734608"
                            id="Stroke-337"
                            strokeWidth="1.07946027"
                        ></path>
                        <path
                            d="M14.3928635,16.2162162 L14.0592845,15.6286688 C13.8749742,15.3048237 13.9905663,14.8861384 14.317319,14.6946072 C14.6440717,14.503076 14.7592088,14.0848533 14.5748984,13.7605456 L14.2417745,13.1734608"
                            id="Stroke-338"
                            strokeWidth="1.07946027"
                        ></path>
                        <path
                            d="M19.1586286,16.2162162 L18.8255047,15.6286688 C18.6411943,15.3048237 18.7563314,14.8861384 19.0830841,14.6946072 C19.4098367,14.503076 19.5254289,14.0848533 19.3411186,13.7605456 L19.0075396,13.1734608"
                            id="Stroke-339"
                            strokeWidth="1.07946027"
                        ></path>
                        <path
                            d="M23.9245756,16.2162162 L23.5909967,15.6286688 C23.4066863,15.3048237 23.5222784,14.8861384 23.8490311,14.6946072 C24.1757838,14.503076 24.290921,14.0848533 24.1070656,13.7605456 L23.7734867,13.1734608"
                            id="Stroke-340"
                            strokeWidth="1.07946027"
                        ></path>
                        <path
                            d="M27.013071,11.103721 L1.36526185,11.103721 C0.611182222,11.103721 0,10.4824011 0,9.71581364 L0,1.38790728 C0,0.620857193 0.611182222,0 1.36526185,0 L27.013071,0 C27.7671507,0 28.3783329,0.620857193 28.3783329,1.38790728 L28.3783329,9.71581364 C28.3783329,10.4824011 27.7671507,11.103721 27.013071,11.103721 Z"
                            id="Stroke-341"
                        ></path>
                        <polygon id="Stroke-342" points="3.57106992 11.1040448 24.5806295 11.1040448 24.5806295 9.29745211 3.57106992 9.29745211"></polygon>
                        <line x1="4.55087287e-05" y1="7.49898269" x2="28.3783784" y2="7.49898269" id="Stroke-343"></line>
                        <line x1="1.70529995" y1="5.00481163" x2="4.15639655" y2="5.00481163" id="Stroke-344"></line>
                        <line x1="5.78740937" y1="5.00481163" x2="7.18088662" y2="5.00481163" id="Stroke-345"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
